import PropTypes from 'prop-types';
import React from 'react';
import { FieldSet } from '../../elements';
import ComplementaryBoleto from './ComplementaryBoleto';
import StudentBoleto from './StudentBoleto';

class ListStudentBoleto extends React.Component {
  render() {
    const {
      complementaryBoletos,
      boleto,
      resubmitting,
      onResubmit,
      showResubmit,
      userCanGenerateBoletos,
      gratuity,
    } = this.props;
    return (
      <>
        <StudentBoleto
          id={boleto}
          resubmitting={resubmitting}
          onResubmit={onResubmit}
          showResubmit={showResubmit}
          userCanGenerateBoletos={userCanGenerateBoletos}
          gratuity={gratuity}
        />
        {complementaryBoletos.length > 0 && (
          <>
            <FieldSet title="Boletos Complementares">
              {complementaryBoletos.map((complementaryBoleto) => (
                <ComplementaryBoleto
                  id={complementaryBoleto.boleto_id}
                  reason={complementaryBoleto.reason}
                />
              ))}
            </FieldSet>
          </>
        )}
      </>
    );
  }
}

ListStudentBoleto.propTypes = {
  boleto: PropTypes.number,
  resubmitting: PropTypes.bool,
  onResubmit: PropTypes.func,
  showResubmit: PropTypes.bool,
  userCanGenerateBoletos: PropTypes.bool,
  complementaryBoletos: PropTypes.arrayOf(
    PropTypes.shape({
      boleto_id: PropTypes.number,
      reason: PropTypes.string,
    })
  ),
  gratuity: PropTypes.shape({
    id: PropTypes.number,
    message: PropTypes.string,
    name: PropTypes.string,
  })
};

ListStudentBoleto.defaultProps = {
  complementaryBoletos: [],
  boleto: undefined,
  showResubmit: false,
  userCanGenerateBoletos: false,
  onResubmit: () => null,
  resubmitting: false,
  gratuity: null,
};

export default ListStudentBoleto;
